import { JSONSchemaFaker } from "json-schema-faker";
export class JsonExampleAdapter {
    schema;
    context;
    artefact;
    baseURL = "";
    constructor(schema, context, artefact) {
        this.schema = schema;
        this.context = context;
        this.artefact = artefact;
    }
    generate = async () => {
        var resultString = await this.generateJsonData(this.schema);
        return { data: resultString };
    };
    async generateJsonData(schema) {
        const json = JSON.parse(schema);
        JSONSchemaFaker.option({ requiredOnly: true, useExamplesValue: true });
        const generatedJson = await JSONSchemaFaker.resolve(json);
        if (generatedJson == null) {
            return "";
        }
        else {
            return JSON.stringify(generatedJson, null, 2);
        }
    }
}
//# sourceMappingURL=json-example-adapter.js.map